export default {"src":"/_next/static/media/logo_cat.7f0bd8b9.svg","height":40,"width":36};